import { render } from "./ResultsEphemerides.vue?vue&type=template&id=509eebcc"
import script from "./ResultsEphemerides.vue?vue&type=script&lang=js"
export * from "./ResultsEphemerides.vue?vue&type=script&lang=js"

import "./ResultsEphemerides.vue?vue&type=style&index=0&id=509eebcc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__